import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { IAMPCustomerDetailsViewModel } from '../../../../models/amp.model';
import { AuthService } from '../../../../services/auth.service';
import { CheckOutService } from '../../../../services/checkout.service';
import { CustomerPaymentsOutput } from '../../../../models/account-ledger.model';
import { takeUntil } from 'rxjs/operators';
import { AdobeService } from '../../../../services/adobe.service';
import { ManageService } from '../../../../services/manage.service';
import { AnnuityViewModel } from '../../../../models/annuity-view.model';
@Component({
  selector: 'dd-amp-customer-details',
  templateUrl: './amp-customer-detail.component.html',
  styleUrls: ['./amp-customer-detail.component.css']
})
export class AMPCustomerDetailsComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private _details = new BehaviorSubject<IAMPCustomerDetailsViewModel>(null);
  public paymentMethod: CustomerPaymentsOutput;
  public annuity: AnnuityViewModel;

  @Input() set details(value: IAMPCustomerDetailsViewModel) { 
    this._details.next(value); 
  };

  get details() {
    return this._details.getValue();
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private checkOutService: CheckOutService,
    public authService: AuthService,
    private adobeService: AdobeService,
    private manageService: ManageService
  ) { }

  ngOnInit() {
    this._details.subscribe(d => {
      if (d) {
        this.manageService.currentAnnuityList.pipe(takeUntil(this.ngUnsubscribe)).subscribe(annuities => {
          if (annuities?.length) {
            this.annuity = annuities.find(a => a.annuityId === this.details.tenantId)
          }
        })

        this.paymentMethod = null;
        if (this.annuity?.customerPaymentNumber) {
          this.checkOutService
            .GetSubscriptionPaymentMethodList()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res) => {
              if (res) {
                this.paymentMethod = res.find((m) => m.out_customer_number === this.annuity?.customerPaymentNumber);
              }
            });
        }
      }
    })
  }

  public editEndUserDetail(event): void {
    event.preventDefault();
    this.router.navigate(['EditAMPEndUser'], { relativeTo: this.activatedRoute });
  }

  public show3YCStatus(): boolean {
    return ['REQUESTED', 'DECLINED', 'REJECTED'].includes(this.details?.customer?.three_year_commitment_status)
  }

  public editPaymentDetails(event): void {
    event.preventDefault();
    this.router.navigate(['EditPaymentDetails'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
